export default theme => ({
    close: {
      padding: theme.spacing(0.5),
    },
});